{
  "alert": "Melding",
  "dismiss": "Negeren"
}
